/* Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Commands } from 'bridge-commands/commands';
import { BridgeService } from '../bridge/bridge.service';
import { Logger, LoggingService } from '../logging/logging.service';
import {
    ClientInfo,
    ComponentName,
    ExceptionInfo,
    SendExceptionInfoParameters,
    SendUserFeedbackInfoParameters
} from './models/exception-info.models';

@Injectable({
    providedIn: 'root'
})
export class ExceptionInfoService {
    private logger: Logger;

    constructor(
        loggingService: LoggingService,
        private bridgeService: BridgeService
    ) {
        this.logger = loggingService.getLogger('crimson/ExceptionInfoService');
    }

    public sendExceptionInfo(
        componentName: ComponentName,
        componentVersion: string,
        exceptionName: string,
        exceptionMessage?: string,
        exceptionString?: string,
        exceptionCode?: number
    ): Observable<any> {
        const clientInfo: ClientInfo = {
            componentName,
            componentVersion
        };

        const exceptionInfo: ExceptionInfo = {
            name: exceptionName ?? '',

            message: exceptionMessage ?? '',

            code: exceptionCode ?? 0,

            stackTrace: exceptionString ?? '',

            clientInfo
        };

        const exceptionInfoParams: SendExceptionInfoParameters = { exceptionInfo };
        this.logger.info('Calling Diagnostics Plugin SendExceptionInfo API With Params:', exceptionInfoParams);

        return this.bridgeService.executeCommand(Commands.Common.Diagnostics.SendExceptionInfo, exceptionInfoParams);
    }

    public SendUserFeedbackInfo(surveyId: string, uiPage: string, uiLanguage: string): Observable<any> {
        const feedbackInfo: SendUserFeedbackInfoParameters = {
            surveyId: surveyId ?? '',

            uiPage: uiPage ?? '',

            uiLanguage: uiLanguage ?? ''
        };

        this.logger.info('Calling Diagnostics Plugin SendUserFeedbackInfo API With Params:', feedbackInfo);

        return this.bridgeService.executeCommand(Commands.Common.Diagnostics.SendUserFeedbackInfo, feedbackInfo);
    }
}
